<template>
  <div v-loading="loading" class="account-setting">
    <div class="user-form">
      <div class="user-img">
        <img v-if="userInfo.FHeadPortraitPath" :src="userInfo.FHeadPortraitPath" class="avatar" @click="replaceAvatar = true">
        <img v-else src="../../../../public/images/notLoginHead@2x.png" class="avatar" @click="replaceAvatar = true">
        <!-- <el-upload
          class="avatar-uploader"
          :show-file-list="false"
          :http-request="uploadImg"
        >
          <div class="upload-box">

            <div class="upload-box">
              <div class="upload-btn">上传图片</div>
            </div>
          </div>
        </el-upload> -->
        <div class="user-text">{{ userInfo.FUserName + '--' + userInfo.funitName }}</div>
        <div class="unit">{{ userInfo.DemandDepartName }}</div>
      </div>

      <div :class="isEdit.account ? 'acc-item acc-item-edit' : 'acc-item'">
        <div class="acc-label"><i class="icon el-icon-user" />账号名称</div>
        <div v-if="!isEdit.account" class="acc-content">{{ userInfo.FUserName }}</div>
        <el-input v-else v-model="editInfo.FUserName" maxlength="20" />
        <div class="acc-edit"><span style="cursor: pointer;" @click="operate('account','FUserName',2)">{{ isEdit.account ? '保存' : '修改' }}</span></div>
      </div>
      <div class="acc-item">
        <div class="acc-label"><i class="icon el-icon-office-building" />所属企业</div>
        <div class="acc-content">{{ userInfo.funitName }}</div>

      </div>
      <div class="acc-item">
        <div class="acc-label"><i class="icon el-icon-lock" />登录密码</div>
        <div class="acc-content">****************</div>
        <div class="acc-edit"><span style="cursor: pointer;" @click="operate('password','password',3)">{{ isEdit.password ? '保存' : '修改' }}</span></div>
      </div>
      <div v-if="isEdit.password" class="acc-item acc-item-edit">
        <div class="acc-label"><span style="color:#FF0000;">*</span>设置新密码</div>
        <el-input v-model="editInfo.FPassword" />
      </div>
      <div v-if="isEdit.password" class="acc-item acc-item-edit">
        <div class="acc-label"><span style="color:#FF0000;">*</span>确认新密码</div>
        <el-input v-model="editInfo.newPassword" />
      </div>
      <div :class="isEdit.phone ? 'acc-item acc-item-edit' : 'acc-item'">
        <div class="acc-label"><i class="icon el-icon-mobile-phone" />手机号</div>
        <div v-if="!isEdit.phone" class="acc-content">{{ userInfo.FPhone | userPhone }}</div>
        <el-input v-else v-model="editInfo.FPhone" maxlength="11" />
        <div class="acc-edit"><span style="cursor: pointer;" @click="operate('phone','FPhone',4)">{{ isEdit.phone ? '保存' : '修改' }}</span></div>
      </div>
    </div>
    <div v-if="replaceAvatar" v-loading="loading" class="replace-avatar">
      <div class="rep-mask" />
      <div class="rep-close" @click="() => { if(!loading) replaceAvatar = false }"><i class="el-icon-close" /></div>
      <div class="rep-img">
        <img v-if="userInfo.FHeadPortraitPath" :src="userInfo.FHeadPortraitPath" class="avatar">
        <img v-else src="../../../../public/images/notLoginHead@2x.png" class="avatar">
      </div>
      <el-upload
        class="avatar-uploader"
        :show-file-list="false"
        :http-request="uploadImg"
      >
        <div class="upload-btn">上传图片</div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request.js'
export default {
  filters: {
    userPhone(val) {
      let str = ''
      if (val) {
        str = val.slice(0, 3) + '****' + val.slice(7, 11)
      }
      return str
    }
  },
  data() {
    return {
      replaceAvatar: false,
      upLoading: false,
      loading: false,
      isEdit: {
        account: false,
        password: false,
        phone: false
      },
      userInfo: {
        FUserId: '',
        FUserName: '',
        FHeadPortraitPath: '',
        FPhone: '',
        funitName: '',
        DemandDepartName: ''
      },
      editInfo: {
        FUserName: '',
        FHeadPortraitPath: '',
        FPhone: '',
        FPassword: '',
        newPassword: ''
      },
      FType: null
    }
  },
  created() {
    this.getUserinfo()
  },
  methods: {
    getUserinfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || null
      if (userInfo) {
        this.userInfo.FUserId = userInfo.fuserId
        this.userInfo.FUserName = userInfo.fuserName
        this.userInfo.FHeadPortraitPath = userInfo.FHeadPortraitPath || ''
        this.userInfo.FPhone = userInfo.fuserPhone
        this.userInfo.funitName = userInfo.funitName
        this.userInfo.DemandDepartName = userInfo.DemandDepartName
      }
    },
    uploadImg(val) {
      this.loading = true
      this.FType = 1
      const params = new FormData()
      params.append('file', val.file)
      request.post('/mall/uploadImg', params)
        .then(res => {
          if (res.result) {
            if (res.imgUrlList[0].result) {
              this.editInfo.FHeadPortraitPath = res.imgUrlList[0].oriUrl
              this.toEdit('image')
            } else {
              this.$message.error(res.imgUrlList[0].message)
            }
          } else {
            this.$message.error('上传图片失败！')
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message.error('上传图片失败！')
        })
    },
    verifyPassword() {
      let valid = ''
      if (this.editInfo.FPassword === '') {
        return (valid = '请输入密码')
      }
      if (this.editInfo.FPassword.length < 8 || this.editInfo.FPassword.length > 16) {
        return (valid = '密码长度为8-16位')
      }
      if (this.editInfo.FPassword.length > 8 || this.editInfo.FPassword.length < 16) {
        const reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/
        if (!reg.test(this.editInfo.FPassword)) {
          return (valid = '密码至少包含字母/数字/ 字符两种组合')
        }
      }
      if (this.editInfo.newPassword === '') {
        return (valid = '请再次输入密码')
      }
      if (this.editInfo.newPassword !== this.editInfo.FPassword) {
        return (valid = '两次输入密码不一致')
      }
    },
    operate(val, str, type) {
      this.FType = type
      if (this.isEdit[val]) {
        switch (val) {
          case ('account') :
            if (!this.editInfo.FUserName) return this.$message.error('账号名称不能为空')
            if (this.editInfo.FUserName == this.userInfo.FUserName) return (this.isEdit.account = false)
            break
          case ('password') :
            if (this.verifyPassword()) return this.$message.error(this.verifyPassword())
            break
          case ('phone') :
            if (!this.editInfo.FPhone) return this.$message.error('手机号不能为空')
            if (this.editInfo.FPhone.length !== 11) return this.$message.error('请输入11位的手机号')
            if (!(/^1[34578]\d{9}$/.test(this.editInfo.FPhone))) return this.$message.error('请输入正确的手机号')
            if (this.editInfo.FPhone == this.userInfo.FPhone) return (this.isEdit.phone = false)
            break
        }
        this.loading = true
        this.toEdit(val)
        return
      }
      this.isEdit[val] = true
      if (str == 'FUserName' || str == 'FPhone') {
        this.editInfo[str] = this.userInfo[str]
      } else {
        this.editInfo.FPassword = this.editInfo.newPassword = ''
      }
    },
    setStorage(str1, str2) {
      this.userInfo[str1] = this.editInfo[str1]
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      userInfo[str2] = this.userInfo[str1]
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
      if (str1 == 'FHeadPortraitPath' || str1 == 'FPhone') {
        this.$store.commit('user/SET_userInfo', userInfo)
      } else if (str1 == 'FUserName') {
        this.$store.commit('user/SET_COMPANY', `${userInfo.fuserName}--${userInfo.funitName}`)
      }
    },
    toEdit(val) {
      const jsonobj = {
        FUserId: this.userInfo.FUserId
      }
      switch (val) {
        case ('account') :
          jsonobj.FUserName = this.editInfo.FUserName
          break
        case ('password') :
          jsonobj.FPassword = this.editInfo.FPassword
          break
        case ('phone') :
          jsonobj.FPhone = this.editInfo.FPhone
          break
        case ('image') :
          jsonobj.FHeadPortraitPath = this.editInfo.FHeadPortraitPath
          break
      }
      const params = new URLSearchParams()
      params.append('FType', this.FType)
      params.append('jsonobj', JSON.stringify(jsonobj))
      request.post('/mall/mallmanage/demanduserdepart/editAccount', params)
        .then(res => {
          if (res.result) {
            switch (val) {
              case ('account') :
                this.userInfo.FUserName = this.editInfo.FUserName
                this.setStorage('FUserName', 'fuserName')
                break
              case ('password') :
                break
              case ('phone') :
                this.setStorage('FPhone', 'fuserPhone')
                break
              case ('image') :
                this.setStorage('FHeadPortraitPath', 'FHeadPortraitPath')
                break
            }
            this.isEdit[val] = false
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss">
.account-setting {
    height: 100%;
    background: #fff;

    .replace-avatar {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;

        .rep-mask {
            width: 100%;
            height: 100%;
            background-color: #000;
            opacity:.5;
        }

        .rep-close {
            z-index: 9999;
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 50%;
            position: absolute;
            top: 40px;
            right: 40px;
            font-size: 24px;
            color: #fff;
            background-color: #606266;
            opacity:.8;
        }

        .rep-img {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        .avatar-uploader {
            position: absolute;
            left: 50%;
            bottom: 30px;
            transform: translateX(-50%);
            .upload-btn {
                width: 282px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                color: #fff;
                background-color: #606266;
                opacity:.8;
                border-radius: 22px;
            }
        }

    }

    .user-form {
        width: 633px;
        margin: auto;
    }

    .user-img {
        text-align: center;
        padding-top: 45px;
        margin-bottom: 32px;
        img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-bottom: 16px;
        }
        .upload-box {
            position: relative;
            width: 120px;
            height: 120px;
            margin-bottom: 16px;
            .upload-box {
                position: absolute;
                top: 0;
                border-radius: 50%;
                background-color: rgba($color: #000000, $alpha: 0.3);
            }
            .avatar {
                width: 120px;
                height: 120px;
                border-radius: 50%;
                // object-fit: contain;
            }
            .upload-btn {
                width: 90px;
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                color: #333333;
                background: #FFFFFF;
                border-radius: 16px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
    }

    .image {
        width: 120px;
        height: 120px;
        padding-bottom: 16px;
        object-fit: contain;
    }

    .user-text {
        font-size: 16px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .unit {
        padding-top: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .acc-item {
        height: 50px;
        display: flex;
        font-size: 16px;
        background: #F3F3F3;
        border-radius: 6px;
        margin-bottom: 20px;
        .el-input__inner {
            height: 48px;
            line-height: 48px;
            border: 0;
            padding-left: 0;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
        }
        .icon{
            padding-right: 7px;
        }
        .acc-label {
            width: 140px;
            flex: none;
            margin: auto 0;
            text-align: left;
            padding-left: 20px;
            box-sizing: border-box;
        }

        .acc-content {
            flex: auto;
            margin: auto 0;
            font-size: 16px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }

        .acc-edit {
            width: 64px;
            flex: none;
            margin: auto 0;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #EC212D;
        }
    }

    .acc-item-edit {
        background-color: #fff;
        border: 1px solid #E1E1E1;
    }

}
</style>
